// A small hand-drawn icon set (24×24, round strokes, currentColor). Icons take
// the colour of their label so a button reads as one piece.
import type { CSSProperties } from 'react';

const PATHS = {
  map: 'M9 4 3 6.5v13.5l6-2.5 6 2.5 6-2.5V4l-6 2.5L9 4Zm0 0v13.5m6-11v13.5',
  people: 'M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-6 9c.6-3.4 3-5.5 6-5.5s5.4 2.1 6 5.5M16 4.3a3.5 3.5 0 0 1 0 6.4M18.5 14.8c1.4.9 2.3 2.6 2.5 5.2',
  chat: 'M4 5.5h16v10H10l-4.5 4v-4H4v-10Zm4 4.5h.01M12 10h.01M16 10h.01',
  bug: 'M9 7.5V6a3 3 0 0 1 6 0v1.5M7 10.5h10v4a5 5 0 0 1-10 0v-4ZM12 10.5V19M3.5 13H7m10 0h3.5M5 7.5l2.5 2M19 7.5l-2.5 2M5 19.5l2.5-2.5M19 19.5 16.5 17',
  building: 'M4 20.5h16M6 20.5V5l7-2v17.5M13 8.5l5 1.8v10.2M9 8h.01M9 11.5h.01M9 15h.01M16 13h.01M16 16.5h.01',
  wheel: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0-6.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM3.5 10.5l6.1 1M14.4 11.5l6.1-1M12 14.5V21',
  shield: 'M12 3 5 6v5.5c0 4.4 3 7.9 7 9.5 4-1.6 7-5.1 7-9.5V6l-7-3Zm-3 9 2.2 2.2L15.5 10',
  bolt: 'M13 2.5 5 13.5h6l-1 8 8-11h-6l1-8Z',
  sun: 'M12 16.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9ZM12 2v2m0 16v2M4.9 4.9l1.4 1.4m11.4 11.4 1.4 1.4M2 12h2m16 0h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4',
  moon: 'M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5Z',
  cloud: 'M7 18.5h10.5a4 4 0 0 0 .4-8A6 6 0 0 0 6.4 11 3.8 3.8 0 0 0 7 18.5Z',
  rain: 'M7 14.5h10.5a4 4 0 0 0 .4-8A6 6 0 0 0 6.4 7 3.8 3.8 0 0 0 7 14.5ZM8 17.5l-1 3m5-3-1 3m5-3-1 3',
  storm: 'M7 13.5h10.5a4 4 0 0 0 .4-8A6 6 0 0 0 6.4 6 3.8 3.8 0 0 0 7 13.5ZM12.5 13l-2.5 4h4l-2.5 4.5',
  fog: 'M4 9h16M6 13h14M4 17h12M7 5h10',
  heat: 'M10 14.5V5a2 2 0 1 1 4 0v9.5a4 4 0 1 1-4 0ZM12 17.5V10',
  truck: 'M2.5 6.5h11v10h-11v-10Zm11 3.5h4l3 3.2v3.3h-7M6.5 19.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm11 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z',
  trailer: 'M3 7h13v8.5H3V7Zm13 6h5M7.5 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z',
  fuel: 'M4.5 20.5V5a1.5 1.5 0 0 1 1.5-1.5h6A1.5 1.5 0 0 1 13.5 5v15.5M3 20.5h12M13.5 9.5h2a1.5 1.5 0 0 1 1.5 1.5v5a1.5 1.5 0 0 0 3 0V8l-3-3M7 8h4',
  wrench: 'M14.5 6.5a4 4 0 0 0 5 5L12 19a2.1 2.1 0 0 1-3-3l7.5-7.5a4 4 0 0 0-2-2Zm0 0L17 4',
  alert: 'M12 3.5 2.5 20h19L12 3.5ZM12 10v4.5m0 2.5h.01',
  play: 'M7 4.5v15l12-7.5-12-7.5Z',
  pause: 'M8 5v14m8-14v14',
  power: 'M12 3v8m5.7-4.7a8 8 0 1 1-11.4 0',
  eye: 'M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Zm9.5 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
  mail: 'M3.5 6h17v12h-17V6Zm0 .5 8.5 7 8.5-7',
  clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0-13.5V12l3 2',
  logout: 'M14 4.5h4.5v15H14M10 8l-4 4 4 4M6 12h10',
  close: 'M6 6l12 12M18 6 6 18',
  chevronLeft: 'M15 5l-7 7 7 7',
  chevronRight: 'M9 5l7 7-7 7',
  camera: 'M3.5 7.5h4l1.5-2.5h6l1.5 2.5h4v11h-17v-11Zm8.5 8.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z',
  sparkle: 'M12 3c.6 4.2 2.3 6.4 6.5 7-4.2.6-5.9 2.8-6.5 7-.6-4.2-2.3-6.4-6.5-7 4.2-.6 5.9-2.8 6.5-7ZM19 15.5c.2 1.6.9 2.3 2.5 2.5-1.6.2-2.3.9-2.5 2.5-.2-1.6-.9-2.3-2.5-2.5 1.6-.2 2.3-.9 2.5-2.5Z',
  horn: 'M4 10v4h3l6 4V6l-6 4H4Zm12.5-1.5a5 5 0 0 1 0 7M19 6a8.5 8.5 0 0 1 0 12',
  target: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0-5a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-4h.01',
  brain: 'M9.5 4.5A3 3 0 0 0 6.6 8 3 3 0 0 0 5 13a3 3 0 0 0 2.5 4.8A2.8 2.8 0 0 0 12 19V6a2.5 2.5 0 0 0-2.5-1.5Zm5 0A3 3 0 0 1 17.4 8 3 3 0 0 1 19 13a3 3 0 0 1-2.5 4.8A2.8 2.8 0 0 1 12 19',
  gauge: 'M4.5 17a8.5 8.5 0 1 1 15 0M12 13.5l4-4.5M12 15a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z',
  list: 'M8.5 6.5h12M8.5 12h12M8.5 17.5h12M4 6.5h.01M4 12h.01M4 17.5h.01',
  send: 'M4 12 20.5 4l-4 16.5-4.5-6.5L4 12Zm8 2 8.5-10',
  dollar: 'M12 3v18M16.5 7.5c-.6-1.6-2.4-2.5-4.5-2.5-2.5 0-4.5 1.3-4.5 3.3 0 4.7 9 2.4 9 7.2 0 2-2 3.5-4.5 3.5-2.4 0-4.2-1-4.8-2.8',
  flag: 'M5 21V4m0 0h11l-2 4 2 4H5',
  key: 'M14.5 13a4.5 4.5 0 1 0-4-4.5L3 16v4.5h4V18h2.5v-2.5H12l1.2-1.2a4.5 4.5 0 0 0 1.3-1.3ZM16 8h.01',
  pin: 'M12 21s-6.5-6-6.5-11a6.5 6.5 0 0 1 13 0c0 5-6.5 11-6.5 11Zm0-8.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z',
  video: 'M3.5 6.5h12v11h-12v-11Zm12 4 5-3v9l-5-3',
  refresh: 'M19.5 7.5A8 8 0 0 0 5 9M4.5 16.5A8 8 0 0 0 19 15M19.5 3.5v4h-4M4.5 20.5v-4h4',
  hand: 'M8 11V5.5a1.5 1.5 0 0 1 3 0V10m0-5.5a1.5 1.5 0 0 1 3 0V10m0-3.5a1.5 1.5 0 0 1 3 0V13c0 4.5-2.5 8-7 8-3 0-4.5-1.5-6-4.5L2.5 12a1.6 1.6 0 0 1 2.6-1.7L8 13.5',
  nfc: 'M6 8.5a5 5 0 0 1 0 7M9.5 6a8.5 8.5 0 0 1 0 12M13 3.5a12 12 0 0 1 0 17',
  zzz: 'M4 6h5L4 12h5M12 10h4l-4 5h4M17 3.5h3.5L17 8h3.5',
  mobile: 'M7.5 3h9v18h-9V3Zm3.5 15h2',
  desktop: 'M3 4.5h18v11.5H3V4.5ZM9 20h6m-3-4v4',
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, size = 20, className, style, title }: { name: IconName; size?: number; className?: string; style?: CSSProperties; title?: string }) {
  return (
    <svg
      className={className}
      style={style}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
    >
      {title ? <title>{title}</title> : null}
      <path d={PATHS[name]} />
    </svg>
  );
}
